export const ERROR_CODE_BAD_REQUEST = 400;
export const ERROR_CODE_UNAUTHORIZED = 401;
export const ERROR_CODE_FORBIDDEN = 403;
export const ERROR_CODE_NOT_FOUND = 404;
export const ERROR_CODE_VALIDATE = 422;
export const ERROR_CODE_SERVER = 500;
export const ERROR_CODE_SERVICE_UNAVAILABLE = 503;
export const ERROR_CODE_REQUEST_TIMEOUT = 408;
